import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "@/components/Sidebar";
import { Topbar } from "@/components/Topbar";
import { cn } from "@/lib/utils";

export function AppShell() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div
      data-testid="app-shell"
      className="flex min-h-screen w-full bg-[hsl(var(--sipx-canvas))] text-foreground"
    >
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((v) => !v)} />
      <div
        className={cn(
          "flex min-w-0 flex-1 flex-col transition-[margin] duration-200 ease-out",
          collapsed ? "md:ml-16" : "md:ml-64"
        )}
      >
        <Topbar />
        <main
          data-testid="main-content"
          className="min-w-0 flex-1 overflow-x-hidden"
        >
          <div className="mx-auto w-full max-w-7xl px-4 py-5 sm:px-6 sm:py-7 lg:px-10 lg:py-10">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
